import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack/Stack';
import { TreeItem2Content, TreeItem2Root, TreeItem2GroupTransition, TreeItem2IconContainer, TreeItem2Label, } from '@mui/x-tree-view/TreeItem2';
import { useTreeItem2 } from '@mui/x-tree-view/useTreeItem2';
import { TreeItem2Icon } from '@mui/x-tree-view/TreeItem2Icon';
import { TreeItem2Provider } from '@mui/x-tree-view/TreeItem2Provider';
import { TreeItem2LabelInput } from '@mui/x-tree-view/TreeItem2LabelInput';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import { isEqual } from 'lodash';
function CustomLabel(_a) {
    var { item, mapping, children, onChange } = _a, props = __rest(_a, ["item", "mapping", "children", "onChange"]);
    const EditContent = props.editContent;
    const editContentProps = props.editContentProps || {};
    return (_jsxs(Stack, { direction: "row", justifyContent: "space-between", spacing: 4, flexGrow: 1, children: [_jsx(Typography, { sx: { display: 'flex', alignItems: 'center', flex: 1 }, children: children }), EditContent ? (_jsx(EditContent, Object.assign({ sx: { flex: 3 }, item: item, mapping: mapping, onChange: onChange }, editContentProps))) : null] }));
}
const CustomTreeItem = React.forwardRef(({ id, itemId, label, disabled, children, editContent, editContentProps, mapping, onChange, }, ref) => {
    const { getRootProps, getContentProps, getLabelProps, getGroupTransitionProps, getIconContainerProps, getLabelInputProps, status, } = useTreeItem2({
        id, itemId, label, disabled, children, rootRef: ref,
    });
    const EditContent = editContent;
    return (_jsx(TreeItem2Provider, { itemId: itemId, children: _jsxs(TreeItem2Root, Object.assign({}, getRootProps(), { children: [_jsxs(TreeItem2Content, Object.assign({}, getContentProps(), { children: [_jsx(TreeItem2IconContainer, Object.assign({}, getIconContainerProps(), { children: _jsx(TreeItem2Icon, { status: status }) })), status.editing ? (_jsx(TreeItem2LabelInput, Object.assign({}, getLabelInputProps()))) : (_jsx(TreeItem2Label, Object.assign({}, getLabelProps()))), EditContent ? (_jsx(EditContent, Object.assign({ sx: { flex: 3 }, mapping: mapping, onChange: onChange, item: {
                                label,
                                id: itemId,
                                children,
                                disabled,
                            } }, (editContentProps || {})))) : null] })), children && _jsx(TreeItem2GroupTransition, Object.assign({}, getGroupTransitionProps()))] })) }));
});
export default function MappingTree({ mapping: mappingProp = {}, tree, idField = 'id', displayField = 'title', slots, slotProps, onChange, }) {
    const [mapping, setMapping] = useState(mappingProp);
    const mappingRef = useRef(mapping);
    if (!isEqual(mappingRef.current, mappingProp)) {
        mappingRef.current = mappingProp;
    }
    useEffect(() => {
        setMapping(mappingRef.current);
    }, [mappingRef.current]);
    return (_jsx(RichTreeView, { expansionTrigger: "iconContainer", items: tree, slotProps: {
            item: {
                editContent: slots === null || slots === void 0 ? void 0 : slots.editContent,
                editContentProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.editContent,
                mapping,
                onChange,
            },
        }, getItemLabel: item => item[displayField], getItemId: item => String(item[idField]), slots: { item: CustomTreeItem } }));
}
